/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    TimeFormats,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';
import TableItem from '@appblocks/codegeneration/SettingsConfigurations/TableItem';
import Cgg from '.';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER = project.getFeature(feature.getSettingValue('TIMER'));
    if (!TIMER) {
        return blocks;
    }
    const TIMER_REPEAT = feature.getSettingValue('REPEAT');

    const TIMER_VAR_NAME = TIMER.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${TIMER_VAR_NAME}`;

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `/****${doneLinks[0].getSourceId()}****/` : '';

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `let ${TIMER_NAME}_timer_repeat = false;`,
    });

    const links = project.getNodeLinks(feature, 'timer_start');
    for (let i = 0; i < links.length; i++) {
        const link = links[i];

        const time = project.getNodeParameter(link, 'time');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
${TIMER_NAME}_timer_repeat = ${TIMER_REPEAT};
var_${TIMER_VAR_NAME}_set(Number(${time}));

${doneBlock}
`,
        });
    }

    return blocks;
};
